export default __webpack_public_path__ + "static/media/Parent_Illustrations-15.83ca2819.svg";